export default "__VITE_ASSET__B2c06i1m__"